<script lang="ts">
    import dayjs from 'dayjs'
    import { ScheduleSlotTime, ScheduleSlotTimeItem } from '../../../modules/schedulerApi/schedules/schedule-slots'
    import { onMount } from 'svelte'
    export let start: number = 0
    export let end: number = 1440
    export let interval: number = 15
    export let slots: ScheduleSlotTime[] = []

    let days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']
    let now = new Date()
    now.setHours(0, 0, 0, 0)

    function loadEmptySlots(_start: number, _end: number, _interval: number) {
        if (!loaded) return
        let weekDay = 0
        slots = []
        if (_interval < 10) _interval = 10
        for (const label of days) {
            let day: ScheduleSlotTime = {
                day: weekDay,
                label: label,
                slots: [],
            }
            for (let index = _start; index < _end; index += _interval) {
                day.slots.push({
                    active: true,
                    start: index,
                    end: index + _interval,
                    label:
                        dayjs(now).add(index, 'minutes').format('HH:mm') +
                        ' - ' +
                        dayjs(now)
                            .add(index + _interval, 'minutes')
                            .format('HH:mm'),
                })
            }
            weekDay++
            slots.push(day)
        }
        slots = slots
    }

    function onMouseEnter(slot: ScheduleSlotTimeItem, force = false) {
        if (!force && !mouseIsDown) return
        slot.active = !slot.active
        slots = slots
    }

    let mouseIsDown = false
    function onMouseDown() {
        mouseIsDown = true
    }
    function onMouseUp() {
        mouseIsDown = false
    }

    let loaded = false
    onMount(() => {
        loaded = true
        if (!slots) {
            loadEmptySlots(start, end, interval)
        }
    })

    $: {
        loadEmptySlots(start, end, interval)
    }
</script>

{#if loaded}
    <div class="root schedule-range" on:mousedown={onMouseDown} on:mouseup={onMouseUp} on:mouseleave={onMouseUp}>
        {#each slots as day}
            <div class="day">
                <div class="label">{day.label}</div>
                {#each day.slots as slot}
                    <div
                        class="slot"
                        class:is-active={slot.active}
                        on:mouseenter={() => onMouseEnter(slot)}
                        on:mousedown={() => onMouseEnter(slot, true)}
                    >
                        <div>{slot.label}</div>
                    </div>
                {/each}
            </div>
        {/each}
    </div>
{/if}

<style>
    .schedule-range {
        background-color: #e57373;
        user-select: none;
        display: flex;
        border-radius: 6px;
        overflow: hidden;
    }
    .schedule-range .label {
        text-align: center;
        background-color: #333;
    }
    .schedule-range .day {
        flex: 1 1 10px;
        font-size: 12px;
        padding: 0px;
        margin: 0px;
    }
    .schedule-range .slot {
        border: 1px solid #99999910;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 12px;
        height: 18px;
    }
    .schedule-range .is-active {
        background-color: #1565c0;
    }
</style>
